import { Directive, ElementRef, Renderer2, HostListener } from '@angular/core';

@Directive({
	selector: '[loopBeginningVideo]'
})
export class LoopBeginningVideoDirective {

	video; 

	constructor(private _elRef: ElementRef, private _renderer: Renderer2) { }

	ngAfterViewInit() {
		this.video = this._elRef.nativeElement;
		let videoDuration;
		let loopTimer = 15;
		//this.video = this._elRef.nativeElement;
		setTimeout( ()=>{
			videoDuration = this.video.duration;
			if (videoDuration < 15){
				loopTimer = videoDuration;
			}
			this.video.addEventListener("timeupdate", function(){
			    if(this.currentTime >= loopTimer) {
			        this.pause();
					this.currentTime = 0;
					this.play();
			    }
			});
		}, 1000);

		/*setInterval(() => {
			this.video.play;
		}, 2000);*/


		/*this.video.addEventListener("timeupdate", function(){
		    if(this.currentTime >= 15) {
		        this.pause();
				this.currentTime = 0;
				this.play();
		    }
		});*/

	}


}
